import { Flex, Form, FormInstance } from "antd";
import Search from "antd/es/input/Search";
import { FC } from "react";
import { weekNumberOptions } from "tm-shared/constants";

import {
    StyledFormItem,
    StyledFormItemRadio,
    StyledRadioBtn,
    StyledRadioGroup,
} from "./Styled";

const dayOptions = [{ value: "0", label: "Всі" }, ...weekNumberOptions];

export interface ScheduleFiltersPanelValues {
    search: string;
    day: string;
}

interface ScheduleFiltersPanelProps {
    form: FormInstance<ScheduleFiltersPanelValues>;
}

export const ScheduleFiltersPanel: FC<ScheduleFiltersPanelProps> = ({
    form,
}) => {
    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={{ search: "", day: "0" }}
        >
            <Flex vertical gap="10px" justify="center" align="center">
                <StyledFormItem name="search">
                    <Search
                        placeholder="Введіть назву"
                        size="large"
                        allowClear
                    />
                </StyledFormItem>

                <StyledFormItemRadio name="day">
                    <StyledRadioGroup size="middle">
                        {dayOptions.map(({ value, label }) => (
                            <StyledRadioBtn key={value} value={value}>
                                {label}
                            </StyledRadioBtn>
                        ))}
                    </StyledRadioGroup>
                </StyledFormItemRadio>
            </Flex>
        </Form>
    );
};
